import { defineStyle } from '@chakra-ui/react';

export const playerVariant = defineStyle({
  height: '72px',
  width: '72px',
  border: '2px solid',
  background: 'neutral.900',
  color: 'neutral.800',
  padding: 2,
  _hover: {
    borderColor: 'skyBlue',
    background: 'neutral.800',
    color: 'skyBlue',
    _disabled: {
      borderColor: 'neutral.800',
      background: 'neutral.900',
      color: 'neutral.300',
    },
  },
  _disabled: {
    cursor: 'default',
  },
  '&[data-active=true]': {
    background: 'blue',
    color: 'neutral.white',
    _hover: {
      borderColor: 'skyBlue',
    },
  },
  _pressed: {
    background: 'blue.600',
    color: 'neutral.white',
  },
});

export const smallPlayerVariant = defineStyle({
  ...playerVariant,
  height: '48px',
  width: '48px',
});
